import translations from '../translations/de';

const genderTypes = [
    { value: 'other', label: translations.other },
    { value: 'female', label: translations.female },
    { value: 'male', label: translations.male },
];

export default genderTypes;
